export default "__VITE_ASSET__C7kH09mx__"